import React from 'react';
import PropTypes from 'prop-types';

function R1Button({ active, activeColor, color }) {
  return (
    <path
      d="M617.653 100.192C614.457 100.195 610.979 100.321 607.357 100.535C602.52 100.818 597.411 101.253 593.835 101.688C590.258 102.124 588.214 102.559 587.032 103.051C585.849 103.543 585.527 104.093 585.234 105.096C584.941 106.099 584.677 107.555 584.298 109.968C583.94 112.247 583.49 115.347 583.305 117.537C585.888 117.346 589.169 117.448 595.28 118.183C602.163 119.012 612.626 120.641 626.63 123.081C640.639 125.52 658.184 128.769 670.438 131.388C676.132 132.605 680.641 133.679 684.257 134.61C683.831 131.424 683.411 128.336 683.071 126.288C682.564 123.299 682.225 122.485 681.298 121.512C680.37 120.538 678.856 119.401 675.067 117.074C671.273 114.748 665.198 111.226 657.58 108.36C649.962 105.493 640.8 103.279 634.501 101.992C628.202 100.706 624.758 100.346 620.756 100.232C619.754 100.204 618.718 100.191 617.653 100.192Z"
      fill={active ? activeColor : color}
    />
  );
}

R1Button.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

R1Button.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#1A1A21',
};

export default R1Button;
